import { Bestek } from "@/models/bestek";
import L, { LatLngBoundsLiteral } from "leaflet";
import { useState } from "react";
import { MapContainer, Marker, Popup, TileLayer } from "react-leaflet";
import withDefaultProps from "with-default-props";
import "leaflet/dist/leaflet.css";
import { useNavigate } from "react-router-dom";

interface Props {
    mapHeight: string,
    bestekken: Bestek[],
    selectedBestek: Bestek | null,
    onBestekSelection: ((b: Bestek) => void) | null,
    allowHighlight: boolean,
    showPopup: boolean,
    showLinkInPopup: boolean
    minPaddingKM: number;
}

const defaultProps: Props = {
    mapHeight: '300px',
    bestekken: [],
    selectedBestek: null,
    allowHighlight: true,
    showPopup: true,
    showLinkInPopup: true,
    onBestekSelection: null,
    minPaddingKM: 5
}

let defaultIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-blue.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -24],
    shadowSize: [41, 41]
});

var selectedIcon = new L.Icon({
    iconUrl: 'https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png',
    shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png',
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -24],
    shadowSize: [41, 41]
});

const BestekkenMap = (props: Props) => {
    const navigate = useNavigate();

    const getBounds = (): LatLngBoundsLiteral => {
        const lats: (number | null)[] = props.bestekken.map(b => b.locatie?.coordinaten_ll?.lat ?? null);
        const lons: (number | null)[] = props.bestekken.map(b => b.locatie?.coordinaten_ll?.lon ?? null);

        const OneKMLat: number = 0.008983;
        const OneKMLon: number = 0.015060;

        const minlat = Math.min(... (lats.filter(l => l !== null) as number[])) - (props.minPaddingKM ?? 0) * OneKMLat;
        const maxlat = Math.max(... (lats.filter(l => l !== null) as number[])) + (props.minPaddingKM ?? 0) * OneKMLat;
        const minlon = Math.min(... (lons.filter(l => l !== null) as number[])) - (props.minPaddingKM ?? 0) * OneKMLon;
        const maxlon = Math.max(... (lons.filter(l => l !== null) as number[])) + (props.minPaddingKM ?? 0) * OneKMLon;

        return [
            [minlat, minlon],
            [minlat, maxlon],
            [maxlat, minlon],
            [maxlat, maxlon]
        ];
    }

    const getBestekkenWithLoc = (): Bestek[] => {
        return props.bestekken.filter(b => {
            return b.locatie && b.locatie.coordinaten_ll && b.locatie.coordinaten_ll.lat && b.locatie.coordinaten_ll.lon;
        });
    }

    if (getBestekkenWithLoc().length === 0) {
        return <div></div>
    }

    return (
        <>
            	<MapContainer 
                    bounds={getBounds()}
                    style={{height: props.mapHeight, borderRadius: '10px', marginBottom: '10px'}}
                >
                    <TileLayer
                        // attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                        />

                    {
                        getBestekkenWithLoc().map(b => {
                            return (
                                <Marker 
                                    key={"map-marker-"+b.id}
                                    position={[b.locatie?.coordinaten_ll.lat ?? 0, b.locatie?.coordinaten_ll.lon ?? 0]} 
                                    eventHandlers={{
                                        click: () => {
                                            if (props.onBestekSelection) {
                                                props.onBestekSelection(b);
                                            }
                                        }
                                    }}
                                    /*
                                    // @ts-ignore */
                                    icon={props.allowHighlight && props.selectedBestek && props.selectedBestek.id === b.id ? selectedIcon : defaultIcon}
                                >
                                    {props.showPopup && (
                                        <Popup>
                                            <b>{b.registratie_nummer}</b> <br /> {b.beschrijving}
                                            { props.showLinkInPopup && (
                                                <>
                                                    <br /><a href="" onClick={() => { navigate(`/bestekken/${b.id}/${b.registratie_nummer}`) } }>Toon bestek</a>
                                                </>
                                            )}
                                        </Popup>
                                    )}
                                </Marker>
                            )
                        })
                    }
                </MapContainer>
        </>
    )
    
}

export default withDefaultProps(BestekkenMap, defaultProps);